import { makeStyles } from '@mui/styles';
import Checkbox from 'apollo-react/components/Checkbox';
import Tooltip from 'apollo-react/components/Tooltip';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';
import {
  getIsAllRecordsAreDisabled,
  getIsAllRecordsPerPageSelected,
  getIsSelectedRecordOnCurrentPage,
} from '../../utils/commonUtils';

const useStyles = makeStyles({
  headerCheckbox: {
    '& .MuiCheckbox-root': {
      top: 0,
    },
    '& .MuiFormControlLabel-label': {
      display: 'none',
    },
    minHeight: '0px !important',
    marginRight: '20px !important',
  },
  tooltipContainer: {
    left: 12,
  },
});

export const MultiSelectHeader = ({
  allRowsPerPage,
  onHeaderMultiselect,
  selections,
  getDisableCriteria,
}) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const isAllRecordsPerPageSelected = getIsAllRecordsPerPageSelected(allRowsPerPage, selections);
  const isSelectedRecordOnCurrentPage = getIsSelectedRecordOnCurrentPage(
    allRowsPerPage,
    selections
  );
  const isAllRecordsAreDisabled = getIsAllRecordsAreDisabled(allRowsPerPage, getDisableCriteria);

  const tooltipTitle =
    (isSelectedRecordOnCurrentPage && !isAllRecordsPerPageSelected) || isAllRecordsPerPageSelected
      ? 'Unselect all the displayed rows'
      : 'Select all the displayed rows';

  const onCheckboxHeaderChange = () => {
    onHeaderMultiselect(allRowsPerPage, isAllRecordsPerPageSelected, isSelectedRecordOnCurrentPage);
  };

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltipContainer }}
      title={translateString(tooltipTitle)}
      placement="top"
    >
      <Checkbox
        className={classes.headerCheckbox}
        disabled={isAllRecordsAreDisabled}
        checked={isAllRecordsPerPageSelected}
        onChange={onCheckboxHeaderChange}
        indeterminate={isSelectedRecordOnCurrentPage && !isAllRecordsPerPageSelected}
        aria-label="Multi Select Header"
      />
    </Tooltip>
  );
};

export const selectAllHeader = (
  rows = [],
  onHeaderMultiselect,
  selections,
  getDisableCriteria = () => {}
) => (
  <MultiSelectHeader
    allRowsPerPage={rows}
    onHeaderMultiselect={onHeaderMultiselect}
    selections={selections}
    getDisableCriteria={getDisableCriteria}
  />
);
